(() => {
  if (window.vlSmoothAnchorLinkInitialized) return;
  window.vlSmoothAnchorLinkInitialized = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-vl-smooth-anchor-link]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    let target;
    try {
      target = document.querySelector(href);
    } catch (error) {
      return;
    }

    if (!target) return;

    event.preventDefault();

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });

    if (window.location.hash !== href) {
      window.history.pushState(null, '', href);
    }
  });
})();
